/* Operational inquiry delivery, separate from Analytics. PII remains in this tab for at most 2 hours. */
(function () {
  'use strict';
  var KEY='hc_crm_queue_v1', ENDPOINT='https://n8n.rayssh.com/webhook/highcool-qualified-inquiry-v1', TTL=7200000, busy=false;
  function get() { try { var x=JSON.parse(sessionStorage.getItem(KEY)||'[]'); return Array.isArray(x)?x.filter(function(i){return i&&i.payload&&Date.now()-i.payload.created_at<TTL&&Date.now()>=i.payload.created_at;}):[]; } catch(e) { return []; } }
  function put(x) { try { sessionStorage.setItem(KEY,JSON.stringify(x.slice(-5))); } catch(e) {} }
  function field(form,name,max) { var el=form.querySelector('[name="contact['+name+']"]'); return el?String(el.value||'').slice(0,max):''; }
  function capture(form,meta) {
    var payload=Object.assign({},meta,{
      name:field(form,'name',200), email:field(form,'email',320), phone:field(form,'phone',100),
      company:field(form,'company',300),body:field(form,'body',10000),heard_about:field(form,'How did you first hear about us',200)
    });
    var q=get().filter(function(i){return i.confirmed||i.payload.form_id!==meta.form_id;});
    q.push({payload:payload,confirmed:false,attempts:0,next:0});put(q);
  }
  function status(box,value) { if(box) box.setAttribute('data-hc-crm-status',value); }
  function confirm(box) {
    var form=box&&box.closest('form'); if(!form) return;
    var q=get();
    // The receipt corresponds to the latest submission on this form only.
    for(var i=q.length-1;i>=0;i--) if(q[i].payload.form_id===form.id) {
      q[i].confirmed=true;q[i].payload.native_success=true;
      box.setAttribute('data-hc-lead-id',q[i].payload.lead_id);status(box,'queued');break;
    }
    put(q);flush(box);
  }
  function flush(box) {
    if(busy||typeof window.fetch!=='function') return;
    var q=get();put(q);
    var item=q.find(function(i){return i.confirmed&&i.next<=Date.now()&&i.attempts<8;});if(!item) return;
    busy=true;
    var controller=window.AbortController?new window.AbortController():null;
    var timeout=setTimeout(function(){if(controller) controller.abort();},12000);
    window.fetch(ENDPOINT,{
      method:'POST',mode:'cors',credentials:'omit',headers:{'Content-Type':'text/plain;charset=UTF-8'},
      body:JSON.stringify(item.payload),signal:controller?controller.signal:undefined
    }).then(function(response){
      if(!response.ok) throw new Error('delivery_pending');return response.json();
    }).then(function(result){
      if(result.accepted!==true||result.lead_id!==item.payload.lead_id) throw new Error('ack_mismatch');
      put(get().filter(function(i){return i.payload.lead_id!==item.payload.lead_id;}));
      status(box,'accepted');
    }).catch(function(){
      var rest=get();rest.forEach(function(i){if(i.payload.lead_id===item.payload.lead_id){i.attempts++;i.next=Date.now()+Math.min(300000,2000*Math.pow(2,i.attempts));}});put(rest);
      status(box,'retry-pending');
    }).finally(function(){clearTimeout(timeout);busy=false;setTimeout(function(){flush(box);},5000);});
  }
  window.HCInquiryCRM={capture:capture,confirm:confirm};
  window.addEventListener('online',function(){flush(document.querySelector('[data-hc-qf-success]'));});
  document.addEventListener('visibilitychange',function(){if(!document.hidden) flush(document.querySelector('[data-hc-qf-success]'));});
  // Only confirmed receipts are retried on other pages; unsent forms never enter the ledger.
  flush();
})();

/* HIGHCOOL inquiry receipt tracking. No customer-entered personal data is sent to Analytics. */
(function () {
  'use strict';
  if (window.HCInquiry) return;
  var GA = 'G-X25W77J27J', PENDING = 'hc_inquiry_pending_v1', ATTR = 'hc_inquiry_attribution_v1';
  var configured = false, receipt = null, sent = {}, DAY = 86400000;
  function read(store, key) { try { return JSON.parse(store.getItem(key) || 'null'); } catch (e) { return null; } }
  function write(store, key, value) { try { store.setItem(key, JSON.stringify(value)); } catch (e) {} }
  function allowed(purpose) {
    try { var p = window.Shopify && window.Shopify.customerPrivacy; return !!(p && p[purpose] && p[purpose]()); } catch (e) { return false; }
  }
  function clean(value) {
    value = String(value || '').slice(0, 100);
    return /^[a-z0-9_. /:+-]*$/i.test(value) && !/\d{7,}/.test(value) ? value : '';
  }
  function pagePath() { return window.location.pathname.slice(0, 240); }
  function campaign() {
    var params = new URLSearchParams(window.location.search), ref = null;
    try { ref = new URL(document.referrer); } catch (e) {}
    var external = ref && ref.hostname !== window.location.hostname;
    // Internal blog UTMs must not replace the original acquisition source.
    var source = clean(params.get('utm_source'));
    if (ref && !external) return null;
    if (!source && !external) return null;
    var medium = clean(params.get('utm_medium'));
    if (!source) {
      source = clean(ref.hostname.replace(/^www\./, ''));
      medium = /(^|\.)(google\.[a-z.]+|bing\.com|duckduckgo\.com|search\.yahoo\.com)$/.test(source) ? 'organic' : 'referral';
    }
    return { source: source || '(direct)', medium: medium || '(none)', campaign: clean(params.get('utm_campaign')), content: clean(params.get('utm_content')), landing_page: pagePath(), at: Date.now() };
  }
  function attribution() {
    if (!allowed('analyticsProcessingAllowed')) return null;
    var old = read(window.localStorage, ATTR), incoming = campaign();
    if (!old || !old.first || Date.now() - old.first.at > 30 * DAY) {
      old = { first: incoming || { source: '(direct)', medium: '(none)', campaign: '', content: '', landing_page: pagePath(), at: Date.now() } };
      old.last = old.first;
    } else if (incoming) old.last = incoming;
    write(window.localStorage, ATTR, old);
    return old;
  }
  function hidden(form, name, value) {
    var input = form.querySelector('[name="contact[' + name + ']"]');
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'contact[' + name + ']'; form.appendChild(input); }
    input.value = String(value || '');
  }
  function prepare(form, root) {
    if (!form.checkValidity()) return null;
    var id = 'HC-' + Date.now().toString(36) + '-' + (window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Math.random().toString(36).slice(2));
    var type = form.querySelector('[data-hc-qf-type]'), a = attribution();
    var product = form.querySelector('[name="contact[product]"]');
    var data = { lead_id: id, form_id: form.id, created_at: Date.now(), request_type: type && type.value === 'sample' ? 'sample' : 'quote', page_path: pagePath(), source_key: clean(root.getAttribute('data-source')), product_line: product ? clean(product.value) : '', is_test: new URLSearchParams(window.location.search).get('hc_test') === '1' };
    if (a) {
      ['source', 'medium', 'campaign', 'content', 'landing_page'].forEach(function (key) {
        data['first_' + key] = a.first[key]; data['last_' + key] = a.last[key];
      });
    }
    Object.keys(data).forEach(function (key) { hidden(form, key, data[key]); });
    hidden(form, 'source_page', data.source_key + ' | ' + data.page_path);
    write(window.sessionStorage, PENDING, data);
    window.HCInquiryCRM.capture(form, data);
    return data;
  }
  function emit(name, data) {
    if (!allowed('analyticsProcessingAllowed') || typeof window.gtag !== 'function') return false;
    if (!configured) {
      window.gtag('config', GA, { send_page_view: false, allow_google_signals: false, allow_ad_personalization_signals: false });
      configured = true;
    }
    // Explicit destination: never broadcast lead events to every Google tag.
    window.gtag('event', name, Object.assign({ send_to: GA, page_location: window.location.origin + pagePath(), page_referrer: '', debug_mode: !!data.is_test }, data));
    return true;
  }
  function deliverReceipt() {
    if (!receipt) return;
    if (receipt.is_test) {
      var box = document.querySelector('[data-hc-qf-success]');
      if (!sent[receipt.lead_id] && emit('hc_inquiry_test', receipt)) {
        sent[receipt.lead_id] = true;
        write(window.sessionStorage, 'hc_inquiry_counted_' + receipt.lead_id, true);
      }
      if (box) box.setAttribute('data-hc-measurement-status', sent[receipt.lead_id] ? 'test-event-queued' : 'consent-pending');
      return;
    }
    if (!sent[receipt.lead_id] && emit('generate_lead', receipt)) {
      sent[receipt.lead_id] = true;
      write(window.sessionStorage, 'hc_inquiry_counted_' + receipt.lead_id, true);
    }
    if (allowed('marketingAllowed') && typeof window.gtag === 'function' && !read(window.sessionStorage, 'hc_inquiry_ads_' + receipt.lead_id)) {
      window.gtag('event', 'conversion', { send_to: 'AW-17546560899/8b1kCKSRt70bEIOL7a5B', transaction_id: receipt.lead_id });
      write(window.sessionStorage, 'hc_inquiry_ads_' + receipt.lead_id, true);
    }
  }
  function success() {
    var box = document.querySelector('[data-hc-qf-success]');
    if (!box) return;
    window.HCInquiryCRM.confirm(box);
    var data = read(window.sessionStorage, PENDING), form = box.closest('form');
    if (!data || !form || data.form_id !== form.id || Date.now() - data.created_at > 2 * 60 * 60 * 1000 || Date.now() < data.created_at || read(window.sessionStorage, 'hc_inquiry_counted_' + data.lead_id)) return;
    try { window.sessionStorage.removeItem(PENDING); } catch (e) {}
    receipt = data;
    box.setAttribute('data-hc-lead-id', data.lead_id);
    box.setAttribute('data-hc-measurement-test', data.is_test ? 'true' : 'false');
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish('highcool:inquiry_submitted', data);
    deliverReceipt();
  }
  function contact(method) { emit('hc_contact_click', { method: method, page_path: pagePath() }); }
  function init() { attribution(); success(); }
  window.HCInquiry = { prepare: prepare, contact: contact };
  document.addEventListener('visitorConsentCollected', function () { attribution(); deliverReceipt(); });
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function' && !window.Shopify.customerPrivacy) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) { attribution(); deliverReceipt(); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

